import AppDispatcher from '../dispatcher/AppDispatcher';
import OrderConstants from '../constants/OrderConstants';

class OrderActionCreator {
  getStatementOrderData(data) {
    AppDispatcher.handleViewAction({
      actionType: OrderConstants.ORDER_DATA,
      data,
    });
  }

  sendOrderRequest(data) {
    AppDispatcher.handleServerAction({
      actionType: OrderConstants.ORDER_TYPE,
      data,
    });
  }

  ordersSuccess(type, status) {
    const data = { type, status };
    AppDispatcher.handleServerAction({
      actionType: OrderConstants.ORDER_SUCCESS,
      data,
    });
  }

  ordersFailure(type, status, error) {
    const data = { type, status, error };
    AppDispatcher.handleViewAction({
      actionType: OrderConstants.ORDER_FAILURE,
      data,
    });
  }

  hidePopup(data) {
    AppDispatcher.handleViewAction({
      actionType: OrderConstants.HANDLE_POPUP,
      data,
    });
  }
}

export default new OrderActionCreator();
